import React from 'react';
import { motion } from 'framer-motion';
export function TruthSection() {
  return <section className="py-12 bg-brand-dark text-brand-cream text-center" data-id="element-253">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-254">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-255">
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-256">
            La verdad simple
          </h2>
          <p className="font-sans text-xl md:text-2xl leading-relaxed opacity-90" data-id="element-257">
            No es falta de disciplina, es{' '}
            <span className="text-brand-gold font-bold" data-id="element-258">falta de sistema</span>.
            No necesitas más fuerza de voluntad, necesitas un plan que funcione
            aunque estés cansada, aunque tengas antojos, aunque la familia pida.
          </p>
          <p className="mt-6 font-sans text-lg text-white italic" data-id="element-259">
            Sin regaños, sin complicaciones.
          </p>
        </motion.div>
      </div>
    </section>;
}